<template>
	<div>
		<div class="the-language-buttons q-mb-sm">
			<q-btn v-for="language in playButtonsSorted?.topTwo" :key="language.id" color="black" icon="play_arrow" class="btn-lang" :label="langCodeOnly(language.code)" @click="setupVideoPlayerModal(project, language.description, language.code)">
				<q-tooltip :delay="1000" anchor="bottom middle" self="top middle">{{ language.description }}</q-tooltip>
				<!-- <q-btn-dropdown
				v-if="playButtonsSorted?.rest?.length"
				label=""
				color="black"
				class="btn-lang btn-lang-dropdown"
			>
				<q-list link>
					<q-item>
						<q-btn
							v-for="language in playButtonsSorted?.rest"
							:key="language.id"
							color="black"
							icon="play_arrow"
							class="btn-lang"
							:label="langCodeOnly(language.code)"
							@click="setupVideoPlayerModal(project, language.description, language.code)"
						>
							<q-tooltip :delay="1000" anchor="bottom middle" self="top middle">{{
								language.description
							}}</q-tooltip>
						</q-btn>
					</q-item>
				</q-list>
			</q-btn-dropdown> --> </q-btn
			><q-btn v-if="playButtonsSorted?.rest?.length" v-on-clickaway="onBlur" label="" color="black" class="btn-lang btn-lang-dropdown" @click="showMoreLanguageButtons = !showMoreLanguageButtons">
				<q-icon name="arrow_drop_down" :class="[showMoreLanguageButtons ? 'rotate-180' : '', 'transition-generic']" />
			</q-btn>
		</div>
		<div class="more-language-buttons-container">
			<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
				<div v-if="showMoreLanguageButtons">
					<div :class="[showMoreLanguageButtons ? 'language-button-container-expanded' : '', 'row', 'language-button-container']">
						<div v-for="language in playButtonsSorted?.rest" :key="language.id" class="col-auto one-language-button-container">
							<q-btn color="black" icon="play_arrow" class="btn-lang" :label="langCodeOnly(language.code)" @click="setupVideoPlayerModal(project, language.description, language.code)">
								<q-tooltip :delay="1000" anchor="bottom middle" self="top middle">{{ language.description }}</q-tooltip>
							</q-btn>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import { mixin as clickaway } from 'vue-clickaway';

	export default {
		name: 'LanguageButtons',
		mixins: [clickaway],
		props: {
			project: {
				type: Object,
				default: function () {
					return {};
				}
			},

			playButtonsSorted: {
				type: Object,
				default: function () {
					return { topTwo: [], rest: [] };
				}
			}
		},

		data() {
			return {
				showMoreLanguageButtons: false
			};
		},

		methods: {
			onBlur() {
				this.showMoreLanguageButtons = false;
			},

			langCodeOnly(language) {
				return language.split('_')[0];
			},

			setupVideoPlayerModal(project, language, languageCode) {
				this.showMoreLanguageButtons = false;
				if (project.type.title === 'interactive') {
					console.log('interactive found!');
					this.$store.dispatch('setInteractiveModal', {
						project: project,
						language: language,
						languageCode: languageCode,
						posterMode: true
					});
					// window.open('/storage/projects/data/' + project.hash_id + '/' + languageCode + '/index.html', '_blank');
				} else {
					this.$store.dispatch('setVideoPlayerModal', {
						project: project,
						language: language,
						languageCode: languageCode,
						posterMode: false
					});
				}
			}
		}
	};
</script>
